import ListMap from '../core/ListMap';
import MetaQuery from './MetaQuery';

class MetaQueryList extends ListMap {
  constructor(args = {}) {
    const {
      data = [],
    } = args;

    super({ ...args, data: data.map(v => new MetaQuery({ ...args, data: v })) });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new MetaQuery({ data: { rel: key } });
  }
}

export default MetaQueryList;
